import type { HubCallback } from "@aws-amplify/core";
import { Hub } from "aws-amplify";

import { AuthError } from "@/lib/auth/errors/auth-error";
import type { AuthInstance } from "@/lib/auth/types";
import { logger } from "@/lib/logger";
import { wrapper } from "./wrapper";

export const confirmRegistration =
  (client: AuthInstance) =>
  async (email: string, code: string): Promise<void> => {
    logger.trace({ email, code }, "confirmRegistration");

    const confirmation = await wrapper(
      () => client.confirmSignUp(email, code) as Promise<string>,
    );

    if (confirmation !== "SUCCESS") {
      // should never happen as it's automated
      throw new AuthError("Failed to verify code");
    }

    return new Promise((res, rej) => {
      const handler: HubCallback = ({ payload }) => {
        const { event } = payload;
        if (event === "autoSignIn") {
          res();
        } else if (event === "autoSignIn_failure") {
          // redirect to sign in page
          logger.trace({ payload }, "hub payload");
          rej(new AuthError("Auth sign in failed!"));
        }
      };
      Hub.listen("auth", handler);
    });
  };
